import { AutogenModelExcisetaxChargeBill, AutogenRowExcisetaxChargeBill } from "./autogen/AutogenModelExcisetaxChargeBill";

export class ModelExcisetaxChargeBill extends AutogenModelExcisetaxChargeBill<RowExcisetaxChargeBill> {
	constructor() {
		super(RowExcisetaxChargeBill);
	}
}

export class RowExcisetaxChargeBill extends AutogenRowExcisetaxChargeBill {
}